/**
 * Converts a JSON object and its potentially binary data (like File or Blob objects) 
 * into a single FormData object for multipart/form-data requests.
 * 
 * @param json The data object to convert. Supported value types are:
 *             - String, Number, Boolean: converted to strings.
 *             - File/Blob: appended directly.
 *             - Objects/Arrays: stringified using JSON.stringify.
 *             - Null: omitted.
 */
export function convertJsonToFormData(json: any): FormData {
    const formData = new FormData();

    Object.entries(json).forEach(([key, value]) => {
        // We skip null or undefined to avoid sending 'null' as strings inadvertently
        if (value === null || value === undefined) return;

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            // Basic primitives are converted to strings
            formData.append(key, String(value));
        } else if (value instanceof File || value instanceof Blob) {
            // Binary data is preserved as is
            formData.append(key, value);
        } else if (typeof value === 'object') {
            // Complexes like arrays or other objects are stringified
            formData.append(key, JSON.stringify(value));
        }
    });

    return formData;
}
